/*
 * Copyright (c) 2017-2021. Code réalisé par IpsoSenso.
 */
import getLoginReducer from '../modules/login/services/loginService/loginReducers';
import { configuration } from '../modules/configuration/configurationReducer'

const reducers = {
  configuration,
  user: getLoginReducer(window.localStorage)
}

export default reducers
